import React from 'react';
import clsx from 'clsx';
import { HtmlContent } from '@tribeplatform/react-components/HtmlContent';
import { T } from '@tribeplatform/react-components/i18n';
import { Card } from '@tribeplatform/react-ui-kit/Card';
import { useSlate } from '../../hooks/index.js';
export const RichTextBlock = ({ textColor, backgroundColor, content, hidden, }) => {
    const { mode } = useSlate();
    if (hidden) {
        return null;
    }
    if (!content && mode === 'live') {
        return null;
    }
    const style = {};
    if (backgroundColor) {
        style.background = backgroundColor;
    }
    return (React.createElement(Card, { className: clsx('overflow-hidden', textColor === 'light' && 'text-white', textColor === 'dark' && backgroundColor && 'text-black'), style: style },
        React.createElement(Card.Content, null, content ? (React.createElement("article", null,
            React.createElement(HtmlContent, { value: content }))) : (React.createElement("p", null,
            React.createElement(T, { id: "Blocks.RichText.InsertRichTextPlaceholder", defaultMessage: "Insert rich text in this block" }))))));
};
//# sourceMappingURL=Block.js.map